module.exports = __webpack_public_path__ + "stylesheets/title-block_fdee2ec9acda613e3a00e1bab08332c6.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/title-block.less
// module id = 5W2z
// module chunks = 118